// src/components/staffing/CandidateDetailsModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import EmployeeExpandedView from '../cards/EmployeeExpandedView';

const CandidateDetailsModal = ({ open, onClose, candidate }) => {
  if (!candidate) return null;
  return (
    <EmployeeExpandedView
      employee={candidate}
      open={open}
      onClose={onClose}
    />
  );
};

CandidateDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  candidate: PropTypes.object
};

export default CandidateDetailsModal;
